import {
    Component,
    OnInit,
    Input,
    OnChanges,
    SimpleChanges,
    Output,
    EventEmitter,
    ChangeDetectorRef
}                              from '@angular/core';
import {MessageCollection}     from '../../shared/api/messages/api.models';
import {Attachment}            from '../../shared/api/attachments/api.models';
import {ContactMomentSettings} from './schema.models';
import {ContactMoment}         from '../../shared/api/bases/proxy/schemas/contactMoments/api.models';

function determineLowerBoundary (messages: any[], messageIndex: number): number {
    var lowerBoundary = 0;

    for (let i = messageIndex; i >= 0; i--) {
        if (messages[i].daySet !== null && messages[i].daySet > lowerBoundary) {
            lowerBoundary = messages[i].daySet;
        }
    }

    return lowerBoundary;
}

function determineUpperBoundary(messages: any[], messageIndex: number, totalDays: number): number {
    var upperBoundary = totalDays;

    for (let i = messageIndex; i < messages.length; i++) {
        if (messages[i].daySet !== null && messages[i].daySet < upperBoundary) {
            upperBoundary = messages[i].daySet;
        }
    }

    return upperBoundary;
}

@Component({
    selector : 'contactMoments',
    template: require('./contact-moments.component.html'),
    styles: [require('./contact-moments.component.scss')]
})

export class ContactMomentComponent implements OnInit, OnChanges {
    @Input()
    public schema: any;

    @Input()
    public moments: ContactMoment[] = [];

    @Input()
    public settings: ContactMomentSettings;

    @Output()
    public changed = new EventEmitter();

    private initDone: boolean = false;

    public contactMoments: any[] = [];
    public days: any[] = [];
    public minutes: number[] = [];

    public newContactMoment: any = {};
    public timeHours: number[] = [];
    public timeMinutes: number[] = [];

    public daysValid = {};
    public allContactMomentsValid: boolean = false;

    public messageTypes: string[] = [];
    public firstMessageTypes: string[] = [];
    public behaviours: string[]  = MessageCollection.behaviours;
    public attachmentTypes: string[] = Attachment.types;

    constructor(private cdr: ChangeDetectorRef) {}

    ngOnInit() {
        this.cdr.detach();

        if (!this.settings) {
            this.settings = new ContactMomentSettings();
        }

        this.contactMoments = [];
        this.days           = [];

        for (let i = 0; i <= 60; i++) {
            this.minutes.push(i);
        }

        ContactMoment.types.forEach((type) => {
            this.messageTypes.push(type);
            this.firstMessageTypes.push(type);

        });

        this.messageTypes.push('follow-up-2');  // Exception 1
        this.messageTypes.push('follow-up-3');  // Exception 2

        this.resetNewContactMoment();

        if (this.schema.duration && this.moments.length > 0) {
            this.populateContactMoments(this.schema.duration, this.moments);
        } else if (this.schema.duration) {
            this.setContactMomentDays(this.schema.duration);
        }

        this.initDone = true;
        this.cdr.reattach();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (this.initDone === false) {
            return;
        }

        this.setContactMomentDays(this.schema.duration);

        if (changes.moments) {
            if (this.moments.length > 0) {
                this.populateContactMoments(this.schema.duration, this.moments);
            } else {
                this.contactMoments = [];
                this.days           = [];

                this.resetNewContactMoment();
            }
        }
    }

    isAddNewContactMomentDisabled(contactMoment: any): boolean {
        if (!contactMoment.type || contactMoment.deviation === '') {
            return true;
        }

        if (!contactMoment.type.match(/^follow-up/)) {
            return false;
        }

        return !contactMoment.firstMessageType;
    }

    addNewContactMoment(event: Event): boolean {
        event.preventDefault();

        var amountOfMessages = 0;

        switch (this.newContactMoment.type) {
            case 'follow-up-2':
                amountOfMessages = 2;
                this.newContactMoment.type = null;
                break;
            case 'follow-up-3':
                amountOfMessages = 3;
                this.newContactMoment.type = null;
                break;
            default:
                this.newContactMoment.firstMessageType = null;
                amountOfMessages = 1;
                break;
        }

        for (let i = 0; i < amountOfMessages; i++) {
            var message = {days : [], daySet: null };

            this.days.forEach(() => {
                message.days.push({
                    hour : null,
                    minute: null,
                    editMode : false,
                    mutable : true
                });
            });

            this.newContactMoment.messages.push(message);
        }

        this.contactMoments.push(this.newContactMoment);
        this.resetNewContactMoment();
        this.valuesChanges();

        return false;
    }

    populateContactMoments(duration: number, moments: ContactMoment[]) {
        var momentsHash = {};

        for (let i = 0; i < duration; i++) {
            this.days.push({ moments : 0 });
        }

        moments.forEach((contactMoment: ContactMoment) => {
            var appContactMoment = momentsHash[contactMoment.parentId];
            let dayIndex         = contactMoment.dayNr - 1;

            if (appContactMoment === undefined) {
                appContactMoment = momentsHash[contactMoment.id] = {
                    type             : contactMoment.contactFilters.messageType,
                    firstMessageType : contactMoment.contactFilters.firstMessageType,
                    attachment       : contactMoment.contactFilters.attachmentType,
                    behaviour        : contactMoment.contactFilters.behaviour,
                    deviation        : contactMoment.deviation,
                    isAbsoluteTime   : contactMoment.isAbsoluteTime,
                    messages         : []
                };

                this.contactMoments.push(appContactMoment);
            } else {
                momentsHash[contactMoment.id] = appContactMoment;
            }

            var message = {days : [], daySet: dayIndex };

            this.days.forEach((day, index) => {
                message.days.push({
                    id       : (index === message.daySet && !this.settings.treatAsNew) ? contactMoment.id : null,
                    parentId : (index === message.daySet && !this.settings.treatAsNew) ? contactMoment.parentId : null,
                    hour     : index === message.daySet ? contactMoment.timeHour : null,
                    minute   : index === message.daySet ? contactMoment.timeMinute : null,
                    editMode : false,
                    mutable  : true
                });
            });

            appContactMoment.messages.push(message);
            this.valuesChanges(appContactMoment);
        });
    }

    removeContactMoment(contactMoment) {
        this.contactMoments.splice(this.contactMoments.indexOf(contactMoment), 1);
        this.valuesChanges();
    }

    displayTimeString(hourOrMinute: number): string {
        if (hourOrMinute > 9) {
            return hourOrMinute + '';
        }

        return '0' + hourOrMinute;
    }

    editTime(contactMoment: any, message: any, time: any, dayIndex: number): void {
        if (time.mutable === false) {
            return;
        }

        time.editMode    = true;
        this.timeHours   = [];
        this.timeMinutes = [];

        // Set the boundaries
        time.minHour   = 0;
        time.minMinute = 0;
        time.maxHour   = 23;
        time.maxMinute = 59;

        let currentMessageIndex = contactMoment.messages.indexOf(message);
        for (let i = currentMessageIndex - 1; i >= 0; i--) {
            if (contactMoment.messages[i].daySet !== dayIndex) {
                continue;
            }

            let currentDay = contactMoment.messages[i].days[contactMoment.messages[i].daySet];

            if (currentDay.hour > time.minHour) {
                time.minHour = currentDay.hour;
            }

            if (currentDay.minute > time.minMinute) {
                time.minMinute = currentDay.minute;
            }
        }

        for (let i = currentMessageIndex + 1; i < contactMoment.messages.length; i++) {
            if (contactMoment.messages[i].daySet !== dayIndex) {
                continue;
            }

            let currentDay = contactMoment.messages[i].days[contactMoment.messages[i].daySet];

            if (currentDay.hour < time.maxHour) {
                time.maxHour = currentDay.hour;
            }

            if (currentDay.minute < time.maxMinute) {
                time.maxMinute = currentDay.minute;
            }
        }

        // Set default hour when this is an empty object
        if (time.hour === null) {
            time.hour = time.minHour;
        }

        // Set default minute when this is an empty object
        if (time.minute === null) {
            time.minute = time.minMinute;

            if (time.minMinute > 0) {
                time.minute += 1;
            }

        }

        for (let i = time.minHour; i <= time.maxHour; i++) {
            this.timeHours.push(i);
        }

        this.setAllowedMinutes(time);
    }

    setAllowedMinutes(time: any): void {
        this.timeMinutes = [];

        let hour   = parseInt(time.hour);

        var min = 0;
        var max = 59;

        if (hour === time.minHour && hour === time.maxHour) {
            min = time.minMinute + 1;
            max = time.maxMinute - 1;
        } else if (hour === time.minHour && time.minMinute !== 0) {
            min = time.minMinute + 1;
            max = 59;
        } else if (hour === time.maxHour) {
            min = 0;
            max = time.maxMinute - 1;
        }

        // This can happen when you've three messages: 1. 08:10, 2. <todo>, 3: 08.11
        if (max <= min) {
            this.timeHours = [];
            return;
        }

        for (let i = min; i <= max; i++) {
            this.timeMinutes.push(i);
        }
    }

    cancelEditTime(time: any): void {
        time.editMode = false;
        time.hour     = null;
        time.minute   = null;
    }

    saveTime(contactMoment: any, message: any, time: any): void {
        time.editMode  = false;
        time.hour      = parseInt(time.hour);
        time.minute    = parseInt(time.minute);

        message.daySet = message.days.indexOf(time);

        this.days[message.daySet].moments += 1;

        this.valuesChanges(contactMoment);
    }

    removeTime(contactMoment: any, message: any, time: any): void {
        time.hour      = null;
        time.minute    = null;

        this.days[message.daySet].moments -= 1;

        message.daySet = null;

        this.valuesChanges(contactMoment);
    }

    private valuesChanges(contactMoment?: any) {
        if (contactMoment) {
            this.determineMutables(contactMoment);
        }

        this.determineAllContactMomentsValid();

        this.changed.emit({
            isValid : this.allContactMomentsValid,
            moments : this.contactMoments
        });
    }

    private determineAllContactMomentsValid(): boolean {
        // Reset the days invalid state
        this.daysValid              = {};
        this.allContactMomentsValid = true;

        // Keep internal hashmap for same time definition
        var dayTimes = {};

        for (let i = 0; i < this.days.length; i++) {
            this.daysValid[i] = false;
            dayTimes[i] = {};
        }

        if (this.contactMoments.length === 0) {
            return this.allContactMomentsValid = !this.settings.allDaysRequired;
        }

        for (let i = 0; i < this.contactMoments.length; i++) {
            for (let j = 0; j < this.contactMoments[i].messages.length; j++) {
                this.contactMoments[i].messages[j].duplicateTime = false;

                if (this.contactMoments[i].messages[j].daySet === null) {
                    this.allContactMomentsValid = false;
                    continue;
                }

                // Check if the contact moments are not specified on the same day and time
                let currentDay = this.contactMoments[i].messages[j].daySet;
                let day        = this.contactMoments[i].messages[j].days[currentDay] as any;

                if (dayTimes[currentDay][day.hour + ':' + day.minute] === undefined) {
                    dayTimes[currentDay][day.hour + ':' + day.minute] = this.contactMoments[i].messages[j];
                } else {
                    this.contactMoments[i].messages[j].duplicateTime                = true;
                    dayTimes[currentDay][day.hour + ':' + day.minute].duplicateTime = true;
                    this.allContactMomentsValid = false;
                }

                this.daysValid[this.contactMoments[i].messages[j].daySet] = true;
            }
        }

        return this.allContactMomentsValid;
    }

    private determineMutables(contactMoment: any): void {
        contactMoment.messages.forEach((message, index) => {
            let lowerBoundary = determineLowerBoundary(contactMoment.messages, index);
            let upperBoundary = determineUpperBoundary(contactMoment.messages, index, this.days.length);

            message.days.forEach((day, subIndex) => {
                day.mutable = subIndex >= lowerBoundary && subIndex <= upperBoundary;
            });
        });
    }

    private setContactMomentDays(days: number): void {
        // Add extra days when needed
        while (days >= this.days.length) {
            this.days.push({
                moments : 0
            });

            this.contactMoments.forEach((contactMoment) => {
                contactMoment.messages.forEach((message) => {
                    message.days.push({
                        hour : null,
                        minute: null,
                        editMode : false,
                        mutable : true
                    })
                });

                this.valuesChanges(contactMoment);
            });
        }

        // Remove when there are too many days
        while (days < this.days.length) {
            this.days.pop();
            this.contactMoments.forEach((contactMoment) => {
                contactMoment.messages.forEach((message) => {
                    message.days.pop();

                    if (message.daySet !== null && message.days.length  <= message.daySet) {
                        message.daySet = null;
                    }
                });

                this.valuesChanges(contactMoment);
            });
        }
    }

    private resetNewContactMoment(): void {
        this.newContactMoment = {
            type: '',
            firstMessageType: '',
            attachment : '',
            behaviour: '',
            deviation: '',
            messages: []
        };
    }

    public getBehaviourAbbreviation(behaviour: string): string {
        switch (behaviour) {
            case MessageCollection.BEHAVIOUR_NOT_AGGRESSIVE:
                return 'na';
            case MessageCollection.BEHAVIOUR_AGGRESSIVE:
                return 'a';
            case MessageCollection.BEHAVIOUR_MODERATELY_AGGRESSIVE:
                return 'ma';
        }

        return behaviour;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/schemas/components/contact-moments.component.ts